import React from 'react';

const SixthPage = () => {
  return (
    <div className="page-section">
      <div className="container mt-4" style={{paddingBottom: '3rem'}}>
        <div className="row align-center">
          <div className="col-md-12 text-center title-text">
            Sản phẩm đầu tiên được xác minh khoa học giúp kéo dài tuổi thọ
          </div>
        </div>
        <div className="row align-center mt-2" >
          <div className="col-md-6 text-center">
            <img src="/images/product5.png" alt="Product" className="img-fluid" style={{ maxWidth: '80%', maxHeight: '500px' }} loading="lazy" />
          </div>
          <div className="col-md-6 text-center">
            <img src="/images/NNM_WEB_2.png" alt="Product" className="img-fluid" style={{ maxWidth: '100%', maxHeight: '550px' }} loading="lazy" />
          </div>
          <div className="col-md-12 text-center" >
            <button className="btn btn-primary btn-buy-now mt-4"
              style={{ padding: '0.48rem 4.8rem' }}
              onClick={() => window.location.href = '#page-section-7'}>
              Mua <i className="fas fa-shopping-cart"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SixthPage;  